import React, {  useEffect, useState,useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"; 
import Box from '@mui/material/Box'; 
import Container from '@mui/material/Container';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField'; 
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import { warningErrorAction } from "actions/ErrorActions";
import "css/generalSettings.css";
import "css/customDialog.css";
import PropTypes from 'prop-types'; 

const initialArticleColor = [
  {
    "id" : 0,
    "indexrowcolors":0,
    "enablecolorarticle":true,
    "color_id" : 0,
    "color_namees" : "",
    "color_nameen" : "",
    "color_codehex": "",
  }
];

const ArticleCreateOrEditColor = ({
  openEditRowColor,
  setOpenEditRowColor,
  openEditNewColor,
  setOpenEditNewColor,
  formArticle,
  setFormArticle,
  editRowColor,
  setEditRowColor, 
  colorToSelect}) => {
  const {t,i18n} = useTranslation(['listDataArticles']); 
  const token = useSelector((state) => state.loginUser.token); 
  const [newColor,setNewColor]= useState(initialArticleColor);
  const [errorsColor, setErrorsColor] = useState({});
  const dispatch = useDispatch();

  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && openEditRowColor) {
        setNewColor(newColor => ({
          ...newColor,
          id:0,
          indexrowcolors:0,
          enablecolorarticle: true,
          color_id:0,
          color_namees:"",
          color_nameen:"",
          color_codehex:""
        }));
        setEditRowColor(initialArticleColor);
        setErrorsColor({}); 
        setOpenEditRowColor(false);
        setOpenEditNewColor(false);
      }
    },[
      setNewColor,
      setErrorsColor, 
      setEditRowColor,
      setOpenEditRowColor,
      openEditRowColor,
      setOpenEditNewColor,
      ]
  );

  const handleCloseNewColor = () => {
    setOpenEditNewColor(false);
    setNewColor(newColor => ({
      ...newColor,
      id:0,
      indexrowcolors:0,
      enablecolorarticle: true,
      color_id:0,
      color_namees:"",
      color_nameen:"",
      color_codehex:""
    }));
    setEditRowColor(initialArticleColor);
    setErrorsColor({});
    setOpenEditRowColor(false);
  };
  
  const handleChangeSelectColor = (event) => { 
    if (event.target.value!==""){
      setNewColor(newColor => ({
        ...newColor,
        color_id:event.target.value,
        color_codehex:colorToSelect.find((key=>key.id===Number(event.target.value))).codehex
      }));
    }
  };

  const handleBlurSelectColor= (e) => {
    handleChangeSelectColor(e);
    setErrorsColor(validateFormColor());
  };

  const handleChangeEnabledColor = () => {
    setNewColor(newColor => ({
      ...newColor,
      enablecolorarticle: !newColor.enablecolorarticle
    }));
  };

  const toggleDrawerNewColor  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseNewColor();
    }
  }

  const validateFormColor = () => {
    let errorsColor = {};
    if (newColor.color_id==="" || newColor.color_id===0 || newColor.color_id===null){
      errorsColor.color_id = 'Text_ColorRequired';
    }
    if (!openEditNewColor){
      if (formArticle.articlecolors.find(item => {return (Number(item.color_id)=== Number(newColor.color_id)) })){
        errorsColor.color_id = 'Text_Color_Exist';
      }
    }else{
      if (formArticle.articlecolors.find((item) => {return(item.indexrowcolors!==newColor.indexrowcolors && Number(item.color_id)=== Number(newColor.color_id)) })){
        errorsColor.color_id = 'Text_Color_Exist';
      }
    }  
    return errorsColor;
  };

  const handleSubmitNewColor = () => {  
    setErrorsColor(validateFormColor());
    let errorsCheckColor=validateFormColor();
    if ((Object.keys(errorsCheckColor).length === 0) 
          && newColor.color_id!==''  
          && newColor.color_id!==0 
          && newColor.color_id!==null ) {
      let colorFound = colorToSelect.find( item => item.id === Number(newColor.color_id));
      if (colorFound!==undefined ) {
          let colorToAdd={
            "id":newColor.id!==null?newColor.id:"",
            "indexrowcolors" : openEditNewColor?newColor.indexrowcolors:formArticle.articlecolors.length>0?formArticle.articlecolors[formArticle.articlecolors.length-1].indexrowcolors+1:1,
            "enablecolorarticle":newColor.enablecolorarticle,
            "color_id":colorFound.id,
            "color_namees":colorFound.namees,
            "color_nameen":colorFound.nameen,
            "color_codehex":colorFound.codehex
        }
        if (!openEditNewColor){
          formArticle.articlecolors.push(colorToAdd);
        }else{
          let idx=formArticle.articlecolors.findIndex(((item) => item.indexrowcolors === newColor.indexrowcolors));
          formArticle.articlecolors[idx]=colorToAdd
        }
        setFormArticle(formArticle => ({
          ...formArticle,
        }))
      }
      handleCloseNewColor();
    }else{
      if (errorsCheckColor.color_id){
        dispatch(warningErrorAction(t(errorsCheckColor.color_id)));
      }else{
        dispatch(warningErrorAction(t('Text_Error_Save_Data')));
      }

    }  
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (openEditNewColor ){
      setNewColor(newColor => ({
        ...newColor,
        id:editRowColor.id!==null?editRowColor.id:"",
        indexrowcolors:editRowColor.indexrowcolors!==null?editRowColor.indexrowcolors:1,
        enablecolorarticle:editRowColor.enablecolorarticle!==null?editRowColor.enablecolorarticle:true,
        color_id:editRowColor.color_id!==null?editRowColor.color_id:0,
        color_namees:editRowColor.color_namees!==null?editRowColor.color_namees:"",
        color_nameen:editRowColor.color_nameen!==null?editRowColor.color_nameen:"",
        color_codehex:editRowColor.color_codehex!==null?editRowColor.color_codehex:""
      
      }));
    }else{
      setNewColor(newColor => ({
        ...newColor,
        id:0,
        indexrowcolors:0,
        enablecolorarticle: true,
        color_id:0,
        color_namees:"",
        color_nameen:"",
        color_codehex:""
      }));
    }
  },[t,token,dispatch,i18n,editRowColor,openEditNewColor]);
  
  return(
    <>
      {openEditRowColor && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerNewColor(false)}
            onOpen={toggleDrawerNewColor(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '500px' }}>
                <br/>
                <div id="myDIV">
                  <h1 className="h1NewStyle px-4 mb-2">{openEditNewColor?t('Text_Color_Article_Edit'):t('Text_Color_Article_New')}</h1>
                </div>  
                <hr className="sidebar-divider d-none d-md-block"/>
                <form className="createColorArticle" onSubmit={handleCloseNewColor}>  
                  <div className="form-floating mb-3 px-4 primary">
                    <div className="form-group">
                      <label className="text-primary">{t('Text_EnableColorArticle')} :</label>
                       <Checkbox  
                          checked={newColor.enablecolorarticle} 
                          onChange={handleChangeEnabledColor} 
                          sx={{
                            '& .MuiSvgIcon-root': { color:"#4e73df",fontSize: 28 }, // Ajusta el tamaño del ícono
                          }}
                        />   
                    </div>

                    <div className="form-group">  
                      <label className="text-primary">{t('Text_Select_Color_Article_Edit')} :</label>
                      <TextField
                        id="color_id"
                        name="color_id"
                        value={ (newColor.color_id === undefined || newColor.color_id ===null || newColor.color_id ===""
                              || newColor.color_id ==="0" || newColor.color_id ===0)?0:newColor.color_id}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        inputProps={{ style: {color:newColor.color_codehex, width: 400}, maxLength: 100, }}
                        variant="outlined"
                        onBlur={handleBlurSelectColor}
                        onChange={handleChangeSelectColor}
                        helperText={errorsColor.color_id!=null?t(errorsColor.color_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (newColor.color_id === undefined || newColor.color_id ===null || newColor.color_id ===""
                            || newColor.color_id ==="0" || newColor.color_id ===0)?0: newColor.color_id
                        }}>
                        <option key={0} value=""/>
                        {!openEditNewColor? 
                          colorToSelect.map((option) => (!formArticle.articlecolors.find((item) => {return(Number(item.color_id)=== Number(option.id))})) &&
                            <option key={option.id} value={option.id}>
                              {(i18n.language==="es"?option.namees:option.nameen)}
                            </option>
                          ):
                          colorToSelect.map((option) => (!formArticle.articlecolors.find((item) => {return(Number(item.indexrowcolors!==newColor.indexrowcolors && item.color_id)=== Number(option.id))})) &&
                            <option key={option.id} value={option.id}>
                              {(i18n.language==="es"?option.namees:option.nameen)}
                            </option>
                          )
                        }
                      </TextField>
                    </div>
                    <hr className="sidebar-divider d-none d-md-block" />
                    <div className="formdi-pending-action-group">
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitNewColor}>
                        {openEditNewColor?t('Button_Update'):t('Button_Create')}
                      </button> 
                      <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleCloseNewColor}>
                        {t('Button_Cancel')}
                      </button>
                    </div>   
                  </div>
                </form>
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ArticleCreateOrEditColor.propTypes = {

  openEditRowColor: PropTypes.bool.isRequired,
  setOpenEditRowColor: PropTypes.func.isRequired,
  openEditNewColor: PropTypes.bool.isRequired,
  setOpenEditNewColor: PropTypes.func.isRequired,
  formArticle: PropTypes.object.isRequired,
  setFormArticle: PropTypes.func.isRequired, 
  setEditRowColor: PropTypes.func.isRequired
};

export default ArticleCreateOrEditColor;